import { useEffect, useState } from 'react';

export const useLocalStorage = <T,>(
  key: string,
  initialValue?: T,
): [T | undefined, (newValue: T) => void] => {
  const [value, setValue] = useState<T | undefined>(initialValue);

  useEffect(() => {
    const item = localStorage.getItem(key);
    if (!item) return;

    try {
      const parsedValue = JSON.parse(item) as T;
      setValue(parsedValue);
    } catch (error) {}

    return;
  }, [key]);

  function set(newValue: unknown) {
    localStorage.setItem(key, JSON.stringify(newValue));
  }

  return [value, set];
};
